var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResource = function SvgResource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.5 2.75a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zM3.25 7c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v4a1.75 1.75 0 0 1-1.5 1.732v5.518H20a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-5.5h-1V17a.75.75 0 0 1-.75.75H8a.75.75 0 0 1-.75-.75v-4.25h-1v5.5H7a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.75v-5.518A1.75 1.75 0 0 1 3.25 11zm15.25 4.25h-1.75V9a.75.75 0 0 0-.75-.75H8a.75.75 0 0 0-.75.75v2.25H5a.25.25 0 0 1-.25-.25V7A.25.25 0 0 1 5 6.75h14a.25.25 0 0 1 .25.25v4a.25.25 0 0 1-.25.25zm-9.75-1.5v6.5h6.5v-6.5z",
    clipRule: "evenodd"
  })));
};
export default SvgResource;